import Backbone from 'backbone';

import { BiteAdminMfaOption } from '@biteinc/enums';

import { KeyCode } from '../enums/key_code';
import { template } from '../template';

app.LoginView = Backbone.View.extend({
  template: template($('#login-template').html()),

  events: {
    'keyup input.username': '_onUsernameKeyUp',
    'keyup input.password': '_onPasswordKeyUp',
    'keyup input.one-time-password': '_onOneTimePasswordKeyUp',
    'change input.username': '_validateInputs',
    'change input.password': '_validateInputs',
    'change input.one-time-password': '_validateInputs',
    'click button.submit': '_submitButtonWasClicked',
    'click button.resend-security-code': '_resendSecurityCodeButtonWasClicked',
  },

  _validateInputs() {
    let isValid = false;

    if (this.mfaView) {
      isValid = this.$oneTimePassword.val().trim().length === 6;
    } else {
      // HACK: We can't detect when Chrome has autofilled the password field by
      // querying the value of the field. However, we can detect if it decided
      // to color it not white (to show that it has been autofilled).
      const passwordColor = getComputedStyle(this.$password[0]).backgroundColor;
      const passwordIsAutoFilled = 'rgb(255, 255, 255)' !== passwordColor;
      isValid =
        this.$username.val().trim().length > 0 &&
        (this.$password.val().length > 0 || passwordIsAutoFilled);
    }

    this._submitButtonIsDisabled = !isValid;
    this.$('button.submit').prop('disabled', !isValid);
  },

  _onUsernameKeyUp(event) {
    this._validateInputs();
    if (KeyCode.Enter === event.keyCode && this.$username.val().trim().length) {
      this.$password.focus();
    }
  },

  _onPasswordKeyUp(event) {
    this._validateInputs();
    if (
      KeyCode.Enter === event.keyCode &&
      this.$username.val().trim().length &&
      this.$password.val().length
    ) {
      this._submitButtonWasClicked();
    }
  },

  _onOneTimePasswordKeyUp(event) {
    this._validateInputs();
    if (KeyCode.Enter === event.keyCode && this.$oneTimePassword.val().trim().length) {
      this._submitButtonWasClicked();
    }
  },

  _submitButtonWasClicked() {
    if (this._submitButtonIsDisabled) {
      return;
    }

    // If the MFA view is displayed, resend the username and password since we don't have a session.
    // Even though the inputs may be hidden, their values are still available.
    const requestBody = {
      username: this.$username.val().trim(),
      password: this.$password.val(),
    };

    if (this.mfaView) {
      requestBody.emailOneTimePassword = this.$oneTimePassword.val().trim();
    }

    this._submitButtonIsDisabled = true;
    this.$message.hide();
    this._adjustAppHeight();
    app.makeRequest(
      'POST',
      this.mfaView ? '/api/auth/login/mfa' : '/api/auth/login',
      requestBody,
      (response) => {
        this._submitButtonIsDisabled = false;

        if (response.mfaRequired) {
          // The only MFA option currently implemented is email, so redirect to that flow.
          // If we add more options, we will need a screen to allow the user choose from the ones
          // available to them.

          this.mfaOption = response.mfaOptions[0];
          this.mfaView = true;
          this._renderMfaView();
        } else {
          // No more steps needed; the user has been logged in.

          if ((this.postLoginUrl || '').length) {
            window.location = this.postLoginUrl;
          } else {
            window.location = '/';
          }
        }
      },
      (error) => {
        this._submitButtonIsDisabled = false;
        this.$message.text(error || '').show();
        this._adjustAppHeight();
      },
    );
  },

  _resendSecurityCodeButtonWasClicked() {
    if (this._resendSecurityCodeButtonIsDisabled) {
      return;
    }

    const username = this.$username.val().trim();
    const password = this.$password.val();

    this._resendSecurityCodeButtonIsDisabled = true;
    this.$message.hide();
    this._adjustAppHeight();
    app.makeRequest(
      'POST',
      '/api/auth/login/mfa/email/send',
      {
        username,
        password,
      },
      (_response) => {
        this._resendSecurityCodeButtonIsDisabled = false;
      },
      (error) => {
        this._resendSecurityCodeButtonIsDisabled = false;
        this.$message.text(error || '').show();
        this._adjustAppHeight();
      },
    );
  },

  _renderMfaView() {
    this.$el.html(
      this.template({
        mfaView: true,
        mfaEmailView: this.mfaOption === BiteAdminMfaOption.Email,
      }),
    );
    this.$oneTimePassword = this.$('input.one-time-password');
    this._validateInputs();
  },

  _adjustAppHeight() {
    this.$el.css('padding', '0px');
    $('body').toggleClass('login-view', true);
    const winHeight = window.innerHeight || $('body')[0].clientHeight;
    const appHeight = Math.ceil(this.$('.login.card').outerHeight()) + 100;

    if (appHeight < winHeight) {
      const margin = (winHeight - appHeight) / 2;
      this.$el.css('padding', `${Math.floor(margin)}px 0`);
    }
  },

  _getParameterByName(name) {
    const url = window.location.href;

    name = name.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  render() {
    this.$el.html(
      this.template({
        mfaView: false,
        mfaEmailView: false,
      }),
    );
    this.$username = this.$('input.username');
    this.$password = this.$('input.password');
    this.$message = this.$('.message');

    const message = this._getParameterByName('msg');
    if (message) {
      this.$message.text(message).toggle(true);
    }
    const url = this._getParameterByName('url');
    if (url) {
      this.postLoginUrl = url + window.location.hash.trim();
    }

    this.$el.css('padding', '0px');

    $(window).on('resize', this._adjustAppHeight.bind(this));
    setTimeout(() => {
      this._adjustAppHeight();
      this.$username.focus();
      this._validateInputs();
    }, 1);

    return this;
  },
});
